import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const fetchStoreConfig = () => API.get("/config").then((r) => r.data);
export const fetchProducts = () => API.get("/products").then((r) => r.data);
export const fetchProduct = (slug) =>
  API.get(`/products/${slug}`).then((r) => r.data);
export const fetchDiscounts = () =>
  API.get("/discounts").then((r) => r.data);
export const submitOrder = (payload) =>
  API.post("/orders", payload).then((r) => r.data);
export const fetchOrder = (id) => API.get(`/orders/${id}`).then((r) => r.data);
export const submitContact = (payload) =>
  API.post("/contact", payload).then((r) => r.data);

// ---- Owner dashboard (admin) ----
export const adminLogin = (email, password) =>
  API.post("/admin/login", { email, password }).then((r) => r.data);
export const adminLogout = () => API.post("/admin/logout").then((r) => r.data);
export const fetchAdminOrders = () =>
  API.get("/admin/orders").then((r) => r.data);
export const updateOrderStatus = (orderId, status) =>
  API.patch(`/admin/orders/${orderId}`, { status }).then((r) => r.data);

// Cents shown only when the amount actually has them ($1,500 / $161.50)
export const formatNZD = (n) =>
  new Intl.NumberFormat("en-NZ", {
    style: "currency",
    currency: "NZD",
    minimumFractionDigits: Number.isInteger(Number(n)) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(n || 0);

export default API;
